import GetArticlesListByCategoryRequestModelBase from '../_generated/modelBases/get-articles-list-by-category-request-model-base';

export default class GetArticlesListByCategoryRequestModel extends GetArticlesListByCategoryRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
